/* unplugin-vue-components disabled */import script from "./dongle-module-charge.vue?vue&type=script&setup=true&lang=js"
export * from "./dongle-module-charge.vue?vue&type=script&setup=true&lang=js"

import "./dongle-module-charge.vue?vue&type=style&index=0&id=5bb842ad&lang=scss&scoped=true"

import exportComponent from "D:\\igencloud_team\\ident-doc-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bb842ad"]])

export default __exports__